// WP-3.7 (M19 TL-1/2, S-29): timeline queries.
import type { TimelineEntityType } from '@pfos/engine';
import { timelineListResponseSchema, type TimelineEntryResponse } from '@pfos/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api';

export const TIMELINE_KEY = ['timeline'] as const;

export interface TimelineFilters {
  partyId?: string;
  projectId?: string;
  entityTypes?: TimelineEntityType[];
}

function filterQuery(filters: TimelineFilters): string {
  const params = new URLSearchParams();
  if (filters.partyId !== undefined) params.set('partyId', filters.partyId);
  if (filters.projectId !== undefined) params.set('projectId', filters.projectId);
  if (filters.entityTypes !== undefined && filters.entityTypes.length > 0) {
    params.set('entityTypes', filters.entityTypes.join(','));
  }
  const qs = params.toString();
  return qs === '' ? '' : `?${qs}`;
}

export function useTimeline(
  filters: TimelineFilters = {},
): UseQueryResult<TimelineEntryResponse[]> {
  return useQuery({
    queryKey: [...TIMELINE_KEY, filters],
    queryFn: async () =>
      timelineListResponseSchema.parse(await api.get(`/api/v1/timeline${filterQuery(filters)}`))
        .entries,
  });
}
